import { render, staticRenderFns } from "./material-idCard.vue?vue&type=template&id=38564d7a&scoped=true&"
import script from "./material-idCard.vue?vue&type=script&lang=js&"
export * from "./material-idCard.vue?vue&type=script&lang=js&"
import style0 from "./material-idCard.vue?vue&type=style&index=0&id=38564d7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38564d7a",
  null
  
)

export default component.exports